import * as yup from "yup";

export const nullableFloatSchema = yup
  .string()
  .nullable(true)
  .transform((value: string, originalValue: string) => {
    return originalValue === "" ? undefined : value;
  })
  .matches(/^[0-9](.)*/, { message: "Podaj prawidłową wartość" });
